import { useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

/**
 * AdminSearch - a simple debounced text search for admin list pages.
 * - Shows a text input and a clear button.
 * - Intended to be placed above the DataTable's entries-per-page control.
 */
export default function AdminSearch({ value, onChange, placeholder = "Cari...", debounceMs = 400 }) {
  const [text, setText] = useState(value || "");
  const timerRef = useRef();

  useEffect(() => {
    setText(value || "");
  }, [value]);

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      if (onChange) onChange(text);
    }, debounceMs);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [text, onChange, debounceMs]);

  const canClear = useMemo(() => (text || "").length > 0, [text]);

  return (
    <MDBox display="flex" alignItems="center" gap={1} px={2} pt={2} pb={1}>
      <MDInput
        value={text}
        onChange={(e) => setText(e.target.value)}
        fullWidth
        placeholder={placeholder}
        size="small"
      />
      <MDButton
        variant="outlined"
        color="secondary"
        size="small"
        disabled={!canClear}
        onClick={() => setText("")}
      >
        Kosongkan
      </MDButton>
    </MDBox>
  );
}

AdminSearch.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  debounceMs: PropTypes.number,
};
